import React from 'react';
import Nav from './components/Nav';
import { Row } from 'antd';

const TEXT = `
DraftFast is an optimizer for DraftKings and FanDuel standard salary games. The site
currently focuses only on NFL main slates. I offer other sports and slates on a
private-consulting, pay-as-you-go basis.

I am offering free premium access to DraftFast for the first two months of the
NFL season. Premium access includes the following:
`;

export default () => (
  <div>
    <Nav />
    <Row span={12} style={{ marginLeft: '20%', marginTop: 50, width: '50%' }}>
      <div>{TEXT}</div>
      <br />
      <ul>
        <li>Tunable models for cash games, GPPs and other game formats</li>
        <li>Custom projections upload</li>
        <li>(Coming soon) Saved optimizer runs</li>
        <li>(Coming soon) GPP historical data analysis</li>
        <li>(Coming soon) Weekly slate analysis e-mail newsletter</li>
      </ul>
      <br />
      <div>
        Join our <a href="https://draftfast.herokuapp.com/">Slack Channel</a> or
        e-mail me with feature requests or just to say hello!
      </div>
    </Row>
  </div>
);



// WEBPACK FOOTER //
// ./src/About.js